import { render, staticRenderFns } from "./BaseActionFooter.vue?vue&type=template&id=a3087888&"
import script from "./BaseActionFooter.vue?vue&type=script&lang=js&"
export * from "./BaseActionFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFooter,VRow,VSpacer})
